"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../shared");

var _shared2 = _interopRequireDefault(require("./shared"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var H5 = _styledComponents["default"].h5.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "h5__H5",
  componentId: "sc-1ul90eu-0"
})(["", ";"], _shared2["default"]);

var _default = H5;
exports["default"] = _default;